export default "__VITE_ASSET__BHXf$She__"